export default '/build/7ee7d6a4.jpg'